export function capitalise(str: string) {
  return str.charAt(0).toUpperCase() + str.slice(1);
}

export function desnake(str: string) {
  return str.replace(/_/g, " ");
}

// Humanise a camelCase, PascalCase, kebab-case or snake_case string
export function humanise(input: string) {
  // Replace all non-alphanumeric characters with spaces
  let result = input.replace(/[^a-zA-Z0-9]+/g, " ");

  // Add spaces before uppercase letters (except the first letter)
  result = result.replace(/([A-Z])/g, " $1");

  // Trim leading/trailing spaces and capitalize the first letter of each word
  result = result.trim().replace(/\b\w/g, (match) => match.toUpperCase());

  return result;
}

export function isPascalCase(str: string) {
  return /^[A-Z][a-zA-Z0-9]*$/.test(str);
}

export function titleCase(str: string) {
  return str
    .split(" ")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(" ");
}

export function capitalisedSentence(str: string) {
  return titleCase(humanise(str));
}
